var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParticipantDashboardLayout',[_c('MatchingProfileForm',{attrs:{"english":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }